import { Button, Form, Input, message, Modal } from 'antd';
import './deleteAccount.scss';
import { useState } from 'react';
import NodeRSA from 'node-rsa';
import JSEncrypt from 'jsencrypt';
import api from '@/api/login';
import taskerApi from '@/api/tasker';
const DeleteTasker = () => {
    const encrypt = new JSEncrypt();
    const [loginForm] = Form.useForm();
    const email = Form.useWatch('email', loginForm);
    const password = Form.useWatch('password', loginForm);
    const [userInfo, setUserInfo] = useState({ email: '', password: '' });
    const onFinish = async (values: any) => {
        try {
            const publicKeyRes = await api.getPublickey();
            if (publicKeyRes.data && publicKeyRes.data.publicKey) {
                encrypt.setPublicKey(publicKeyRes.data.publicKey);
                const encryptPassword = encrypt.encrypt(values.password);
                if (!encryptPassword) return;
                await onVerify(values.email, encryptPassword);
            }
        } catch (error: any) {
            message.error(error);
        }
    };
    const onVerify = async (email: string, password: string) => {
        try {
            const res = await taskerApi.verifyTasker({ email, password });
            setUserInfo({ email, password });
            isVerify(true);
        } catch (error: any) {
            message.error(error);
        }
    };
    const onFinishFailed = (errorInfo: any) => {
        message.error(errorInfo.errorFields[0].errors[0]);
    };
    const [verify, isVerify] = useState(false);
    const [modalOpen, setOpen] = useState(false);
    const onDelete = async () => {
        try {
            const res = await taskerApi.deleteTaskerAccount(userInfo);
            setOpen(false);
            window.close();
        } catch (error: any) {
            message.error(error);
        }
    };
    return (
        <div className="delete-account">
            <div className="header-wrap">
                <img src={require('@/assets/images/faastaa_logo.png')} alt="" />
            </div>
            <div className="main-wrap">
                <div className="h2">
                    {verify ? 'Delete your Faastaa Tasker account permanently' : 'Delete Faastaa’s account'}
                </div>
                <div className="tip-wrap">
                    {verify
                        ? 'Thank you for your use of our platform and your support.'
                        : 'In order to confirm the account, you need to verify your account number and password'}
                </div>
                {verify ? (
                    <div className="login-form">
                        <div className="tip-wrap">
                            Naturally we are sorry to see you go, please note that when you confirm deletion that all of
                            your data on the Faastaa platform including but not limited to personal information, contact
                            information, photos etc, will not be retrievable.
                        </div>
                        <div className="tip-wrap">All jobs must be completed before an account can be deleted.</div>
                        <Button type="primary" danger className="submit-btn" onClick={() => setOpen(true)}>
                            Delete account
                        </Button>
                    </div>
                ) : (
                    <div className="login-form">
                        <Form
                            form={loginForm}
                            name="login-form"
                            layout="vertical"
                            onFinish={onFinish}
                            onFinishFailed={onFinishFailed}
                            validateTrigger="onBlur"
                            autoComplete="off"
                        >
                            <Form.Item
                                label="Email"
                                name="email"
                                rules={[
                                    { required: true, message: 'Please type your email address!' },
                                    { type: 'email', message: 'Please enter a valid email address' },
                                    {
                                        validator: (rule, value) => {
                                            const reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
                                            if (reg.test(value)) {
                                                return Promise.resolve();
                                            } else {
                                                return Promise.reject('Please enter a valid email address');
                                            }
                                        },
                                    },
                                ]}
                            >
                                <Input className="default_input" />
                            </Form.Item>
                            <Form.Item
                                label="Password"
                                name="password"
                                rules={[
                                    { required: true, message: 'Please type your password!' },
                                    { min: 6, max: 16, message: 'Password must be between 6 and 16' },
                                ]}
                            >
                                <Input.Password className="default_input" maxLength={16} iconRender={() => <></>} />
                            </Form.Item>
                        </Form>
                        <Button
                            type="primary"
                            className="submit-btn"
                            disabled={!email || !password}
                            onClick={() => loginForm.submit()}
                        >
                            Confirm
                        </Button>
                    </div>
                )}
            </div>
            <Modal
                maskClosable={false}
                centered
                open={modalOpen}
                closeIcon={<img src={require('@/assets/images/Icons_Cross.png')} onClick={() => setOpen(false)} />}
            >
                <div className="modal-title" style={{ color: '#FF2626' }}>
                    Delete Account
                </div>
                <div className="modal-tip tip-font-20">Are you sure you want to delete this account?</div>
                <div className="flex-center" style={{ marginTop: 30, columnGap: 20 }}>
                    <Button className="submit-btn" onClick={() => setOpen(false)}>
                        Cancel
                    </Button>
                    <Button className="submit-btn" type="primary" danger onClick={onDelete}>
                        Yes, delete
                    </Button>
                </div>
            </Modal>
        </div>
    );
};
export default DeleteTasker;
